module.exports = __webpack_public_path__ + "img/icon-warning-skogbrannfare-2.847bdb9e.svg";